import { render, staticRenderFns } from "./resumenPedido.vue?vue&type=template&id=69c96f8c&scoped=true&"
import script from "./resumenPedido.vue?vue&type=script&lang=js&"
export * from "./resumenPedido.vue?vue&type=script&lang=js&"
import style0 from "./resumenPedido.vue?vue&type=style&index=0&id=69c96f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c96f8c",
  null
  
)

export default component.exports